import React from 'react';
import PropTypes from 'prop-types';
// MATERIAL UI
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
// ICONS
import NavigationClose from '@mui/icons-material/Close';
import NavigationCheck from '@mui/icons-material/Check';
import { white } from '../../../styles/miEdgeColors';
import { zuiBlue } from '../../../styles/colors/zuiBlue';
// LIBS
import format from 'date-fns/format';

const tableCellSx = (theme) => ({ padding: theme.spacing(1) });

class ExportHistoryDlg extends React.Component {
  render() {
    const { onCloseRequested, open } = this.props;

    return (
      <Dialog maxWidth="sm" fullWidth={true} open={open} onClose={onCloseRequested}>
        <DialogTitle
          sx={(theme) => ({
            backgroundColor: zuiBlue[500],
            padding: theme.spacing(2),
          })}
        >
          <Typography
            sx={{
              color: white,
              fontSize: '16px',
            }}
            variant="h4"
            component="div"
          >
            View Export History (Past 48 Hours)
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={(theme) => ({
            paddingTop: `${theme.spacing(1)} !important`,
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
            maxHeight: '300px',
            height: '300px',
            minHeight: '300px',
          })}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell width="25%" sx={tableCellSx}>
                  Request Date
                </TableCell>
                <TableCell width="20%" sx={tableCellSx}>
                  Export Type
                </TableCell>
                <TableCell width="20%" sx={tableCellSx}>
                  Process Status
                </TableCell>
                <TableCell width="15%" sx={tableCellSx}>
                  Email Sent
                </TableCell>
                <TableCell width="20%" sx={tableCellSx}>
                  Download Link
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.exportHistoryList && this.props.exportHistoryList.length === 0 && (
                <TableRow key="0">
                  <TableCell colSpan="5">There is no export history information.</TableCell>
                </TableRow>
              )}
              {this.props.exportHistoryList &&
                this.props.exportHistoryList.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell width="25%" sx={tableCellSx}>
                      {format(row.requested_at, 'MM/DD/YYYY hh:mm:ss')}
                    </TableCell>
                    <TableCell width="20%" sx={tableCellSx}>
                      {row.report_type}
                    </TableCell>
                    <TableCell width="20%" sx={tableCellSx}>
                      {row.process_status}
                    </TableCell>
                    <TableCell width="15%" sx={tableCellSx}>
                      {this.setEmailSent(row.mail_sent)}
                    </TableCell>
                    <TableCell width="20%" sx={tableCellSx}>
                      <a
                        href={row.download_url}
                        target={
                          row.report_type.toUpperCase() === 'DASHBOARD PDF' ? '_blank' : undefined
                        }
                        rel="noopener noreferrer"
                      >
                        {' '}
                        {this.setDownloadFileName(row.file_name, row.download_url)}{' '}
                      </a>
                    </TableCell>
                    {/* <TableCell style={styles.tableBodyCell} width='21%'><Link href={row.download_url} target='_blank' rel="noreferrer">{this.setDownloadFileName(row.file_name, row.download_url)}</Link></TableCell> */}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={onCloseRequested}
            sx={(theme) => ({
              fontSize: '13px',
              margin: theme.spacing(1),
            })}
          >
            <NavigationClose />
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  componentDidMount() {
    window.addEventListener('keyup', this.handleKeyUp);
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.handleKeyUp);
  }

  // Enter ESC to close the dialog
  handleKeyUp = (event) => {
    if (this.props.open) {
      event = event || window.event;
      let isEscape = false;
      if ('key' in event) {
        isEscape = event.key === 'Escape' || event.key === 'Esc';
      } else {
        isEscape = event.keyCode === 27;
      }
      if (isEscape) {
        this.props.onCloseRequested();
      }
    }
  };

  setDownloadFileName = (file_name, download_url) => {
    let fileName = file_name ? file_name : '';
    if (fileName === '' && download_url !== '') fileName = 'download';
    if (download_url === '') fileName = '';
    if (fileName.length > 15) return <span title={fileName}>{fileName.substr(0, 15)}..</span>;

    return fileName;
  };

  setEmailSent = (mail_sent) => {
    let checkmark = '';
    if (mail_sent === '&#10004;') checkmark = <NavigationCheck />;
    return checkmark;
  };
}

ExportHistoryDlg.propTypes = {
  open: PropTypes.bool.isRequired,
  onCloseRequested: PropTypes.func.isRequired,
  exportHistoryList: PropTypes.array,
};

export default ExportHistoryDlg;
